import _ from 'lodash'

import {
  UPLOAD_ACCEPTED_FILES_ADD,
  UPLOAD_ACCEPTED_FILE_REMOVE,
  UPLOAD_CLEAR,
  UPLOAD_UPLOADED_FILES_ADD,
  UPLOAD_UPLOADED_FILES_REMOVE,
  UPLOAD_TABLE_UPDATE_BY_ID,
  UPLOAD_TABLE_UPDATE,
  UPLOAD_TABLE_REFRESH,
  UPLOAD_DEFAULTS,
  UPLOAD_TABLE_REFRESH_FILE_TAG
} from '../types'

const initialState = {
  uploadedTable: {
    keys: [],
    rows: []
  },
  uploadedFiles: [],
  acceptedFiles: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case UPLOAD_UPLOADED_FILES_ADD:
      return {
        ...state,
        uploadedFiles: [
          ...state.uploadedFiles,
          action.payload
        ]
      }

    case UPLOAD_ACCEPTED_FILE_REMOVE:
      return {
        ...state,
        acceptedFiles: state.acceptedFiles.filter(file => file.name !== action.payload)
      }

    case UPLOAD_ACCEPTED_FILES_ADD:
      return {
        ...state,
        acceptedFiles: [
          ...state.acceptedFiles,
          ...action.payload
        ]
      }

    case UPLOAD_UPLOADED_FILES_REMOVE:
      return {
        ...state,
        uploadedFiles: state.uploadedFiles.filter(file => file.guid !== action.payload)
      }

    case UPLOAD_CLEAR:
      return {
        ...state,
        acceptedFiles: initialState.acceptedFiles
      }

    case UPLOAD_TABLE_UPDATE_BY_ID:

      if (state.uploadedTable.keys.includes(action.payload)) {
        return {
          ...state,
          uploadedTable: {
            ...state.uploadedTable,
            keys: state.uploadedTable.keys.filter(id => id !== action.payload),
            rows: state.uploadedTable.rows.filter(file => file.id !== action.payload)
          }
        }
      } else {
        return {
          ...state,
          uploadedTable: {
            ...state.uploadedTable,
            keys: [
              ...state.uploadedTable.keys,
              action.payload
            ],
            rows: [
              ...state.uploadedTable.rows,
              state.uploadedFiles.filter(file => file.id === action.payload)[0]
            ]
          }
        }
      }

    case UPLOAD_TABLE_UPDATE:

      if (action.payload === true) {
        return {
          ...state,
          uploadedTable: {
            keys: state.uploadedFiles.map(file => file.id),
            rows: state.uploadedFiles
          }
        }
      } else {
        return {
          ...state,
          uploadedTable: {
            keys: [],
            rows: []
          }
        }
      }

    case UPLOAD_TABLE_REFRESH:
      return {
        ...state,
        uploadedFiles: state.uploadedFiles.map(file => _.find(action.payload, (row) => row.id === file.id)),
        uploadedTable: {
          keys: state.uploadedTable.keys,
          rows: state.uploadedTable.rows.map(file => _.find(action.payload, (row) => row.id === file.id))
        }
      }

    case UPLOAD_TABLE_REFRESH_FILE_TAG:

      return {
        ...state,
        uploadedFiles: state.uploadedFiles.map(file => file.guid === action.payload.guid ? {
          ...file,
          tags: file.tags.filter(tag => tag.id === action.payload.data.id).length > 0 ? file.tags.filter(tag => tag.id !== action.payload.data.id) : [
            ...file.tags,
            action.payload.data
          ]
        } : file),
        uploadedTable: {
          keys: state.uploadedTable.keys,
          rows: state.uploadedTable.rows.map(file => file.guid === action.payload.guid ? {
            ...file,
            tags: file.tags.filter(tag => tag.id === action.payload.data.id).length > 0 ? file.tags.filter(tag => tag.id !== action.payload.data.id) : [
              ...file.tags,
              action.payload.data
            ]
          } : file)
        }
      }

    case UPLOAD_DEFAULTS:
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/upload.js